import * as React from 'react';

function SortAmountUpIcon(props) {
  return (
    <svg {...props} viewBox="0 0 512 512">
      <path d="M3.3 107.8l68-72a12 12 0 0 1 17.4 0l68 72A12 12 0 0 1 148 128h-44v340a12 12 0 0 1-12 12H68a12 12 0 0 1-12-12V128H12a12 12 0 0 1-8.7-20.2zM236 136h264a12 12 0 0 0 12-12v-24a12 12 0 0 0-12-12H236a12 12 0 0 0-12 12v24a12 12 0 0 0 12 12zm-12 84v-24a12 12 0 0 1 12-12h200a12 12 0 0 1 12 12v24a12 12 0 0 1-12 12H236a12 12 0 0 1-12-12zm0 192v-24a12 12 0 0 1 12-12h72a12 12 0 0 1 12 12v24a12 12 0 0 1-12 12h-72a12 12 0 0 1-12-12zm0-96v-24a12 12 0 0 1 12-12h136a12 12 0 0 1 12 12v24a12 12 0 0 1-12 12H236a12 12 0 0 1-12-12z" />
    </svg>
  );
}

export default SortAmountUpIcon;
